/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Agents_P_Cli_TitleInputs */

const en_cad_agents_p_cli_title = /** @type {(inputs: Cad_Agents_P_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Headless CLI`)
};

/**
* | output |
* | --- |
* | "Headless CLI" |
*
* @param {Cad_Agents_P_Cli_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_agents_p_cli_title = /** @type {((inputs?: Cad_Agents_P_Cli_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Agents_P_Cli_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_agents_p_cli_title(inputs)
});
export { cad_agents_p_cli_title as "cad.agents.p_cli_title" }